import React from 'react';
import DashboardCard from '../shared/DashboardCard';
import CircularProgressWidget from '../shared/CircularProgressWidget';

interface AgencyComplianceWidgetProps {
    completionRate: number;
    completedItems: number;
    totalItems: number;
    label?: string;
    iconVariant?: 'blue' | 'green' | 'amber' | 'red' | 'purple';
    loading?: boolean;
}

const AgencyComplianceWidget: React.FC<AgencyComplianceWidgetProps> = ({
    completionRate,
    completedItems,
    totalItems,
    label = 'Agency Compliance',
    iconVariant,
    loading,
}) => {
    const variant = iconVariant ?? (completionRate >= 90 ? 'green' : completionRate >= 70 ? 'amber' : 'red');

    return (
        <DashboardCard
            title={label}
            loading={loading}
        >
            <CircularProgressWidget
                value={completionRate}
                size={130}
                strokeWidth={11}
                completed={completedItems}
                total={totalItems}
            />
        </DashboardCard>
    );
};

export default AgencyComplianceWidget;
